import './style.sass';

import React from 'react';

const DescriptionCaseMain = ({ item }) => {
    return (
        <div className="description-case-main">
            {item.text.map(text => (
                <div key={text} className="description-case-main__container">
                    <div
                        dangerouslySetInnerHTML={{ __html: text.paragraph }}
                        className="description-case-main__paragraph"
                    />
                </div>
            ))}
        </div>
    );
};
export default DescriptionCaseMain;
